import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: teacher" */ "@/view/teacher/index.vue"),
    // import(/* webpackChunkName: home" */ "@/view/home/Home.vue"),
  },
  {
    path: "/demo",
    name: "DemoItem",
    component: () =>
      import(/* webpackChunkName: "DemoItem" */ "@/view/demo/DemoItem.vue"),
  },
  {
    path: "/money",
    name: "Money",
    component: () =>
      import(/* webpackChunkName: "Money" */ "@/view/money/index.vue"),
  },
  {
    path: "/check",
    name: "Check",
    component: () =>
      import(/* webpackChunkName: "Money" */ "@/view/check/index.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
